import './godfatherBox.css';
import React, { useState, useContext } from 'react';
import DiamondsGroup from 'components/DiamondsGroup/DiamondsGroup';
import RolesGroup from 'components/RolesGroup/RolesGroup';
import Button from 'components/Styled/Button/Button';
import RolePopup from 'components/RolePopup/RolePopup';
import SocketProvider from 'components/Provider/SocketProvider';
import RoomProvider from 'components/Provider/RoomProvider';
import gfGroupTypes from 'others/game/gfGroupTypes';
import DiscardRole from 'components/DiscardRole/DiscardRole';
import { isLpOnRightOf } from 'others/game/utils';

function GodfatherBox(props) {
    const [selectedRole, setSelectedRole] = useState(null);
    const [showRolePopup, setShowRolePopup] =  useState(false);
    const [showDiscardRole, setShowDiscardRole] = useState(false);

    const { socket } = useContext(SocketProvider);
    const { room } = useContext(RoomProvider);

    const lpIsGodfather = room.localPlayer?.role?.name == 'GodFather';

    const readOnly = room.status != 'Playing' || (room.memorizeGfBox && !lpIsGodfather);
    const roleGroupReadyOnly = readOnly || lpIsGodfather;

    const validate_click = ()=> {
        if(selectedRole){
            setShowRolePopup(true);
        }
    }

    const applyRole = (roleToDiscard)=>{
        const data = { 
            selectedRole, 
            player: room.localPlayer, 
            roomName: room.name,
            roleToDiscard
        };
        socket.emit('chooseRole', data);
    }

    const chooseRole = ()=>{
        if(selectedRole != null){
            if(isLpOnRightOf(room.godFatherIndex, room.localPlayer, room.players)){
                setShowDiscardRole(true)
            }
            else {
                applyRole(null);
            }
            setShowRolePopup(false);
        }
    }

    const handleYesDiscardRole = (role)=>{
        if(role != null){
            applyRole(role);
            setShowDiscardRole(false);
        }
    }

    const handleNoDiscardRole = ()=>{
        applyRole(null);
        setShowDiscardRole(false);
    }

    if(room.localPlayer?.role?.name == 'GodFather' && selectedRole == null){
        setSelectedRole(gfGroupTypes.diamond(0, true));
    }
    
    return (
        <div id='godfatherbox_container' >
            <DiamondsGroup selectedCount={selectedRole?.value} onDiamondClick={setSelectedRole} />
            <RolesGroup 
                readOnly={roleGroupReadyOnly}
                selectedRole={selectedRole?.role} 
                onRoleSelected={setSelectedRole} 
            />
            {
                room.status != 'Debate' && !readOnly && <Button 
                                                            disabled={room.status != 'Playing'}
                                                            onClick={validate_click}
                                                        >
                                                            Suivant
                                                        </Button>
            }
            <RolePopup 
                open={showRolePopup}
                handleClose={()=>setShowRolePopup(false)}
                onChooseRole={chooseRole}
                role={selectedRole}
            />
            <DiscardRole 
                open={showDiscardRole}
                handleNo={handleNoDiscardRole}
                handleYes={handleYesDiscardRole}
                selectedRole={selectedRole?.role}
            />
        </div>
    );
}

export default GodfatherBox;